import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CompareDrawer from 'components/Catalog/ProductGrid/CompareDrawer/CompareDrawer';
import CatalogEN from 'components/Catalog/locales/Catalog_en_US.js';
import CatalogFR from 'components/Catalog/locales/Catalog_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CatalogEN, CatalogFR);

const withCompareDrawerLocale = wrapHOC(WrappedComponent => {
    const CompareDrawerWithLocale = props => (
        <WrappedComponent
            {...props}
            getText={getText}
        />
    );

    return CompareDrawerWithLocale;
});

export default withCompareDrawerLocale(CompareDrawer);
